<template>
  <div id="aqt_content">
    <!--      选项卡开始-->
    <!--      <yd-tab color="#D3DFFF"  :callback="fn"   active-color="#0070D2" bg-color="#1D3662"  height="3.5rem" font-size="0.9rem">-->
    <!--        <yd-tab-panel label="全部" >-->
    <!--          <div class="selected_cars" v-for="(item, index) in newsArr" :key="index">-->
    <!--              <router-link :to="{path:'/Details',query:{id:newsArr[index].news_id}}">-->
    <!--                  <img :src="item.picname" alt=""  class="news_img"/>-->
    <!--                  <div class="text">-->
    <!--                      <p class="time">{{item.addtime}}</p >-->
    <!--                      <p class="news_content">{{item.title}}</p >-->
    <!--                      <p class="news_more">详细内容...</p>-->
    <!--                      <div class="line_under"></div>-->
    <!--                  </div>-->
    <!--              </router-link>-->
    <!--          </div>-->
    <!--        </yd-tab-panel>-->
    <!--        <yd-tab-panel  v-if="news_classify.length" :label="news_classify[1].title">-->
    <!--            <div class="selected_cars" v-for="(item, index) in newsArr" :key="index">-->
    <!--                <router-link :to="{path:'/Details',query:{id:newsArr[index].news_id}}">-->
    <!--                    <img :src="item.picname" alt=""  class="news_img"/>-->
    <!--                    <div class="text">-->
    <!--                        <p class="time">{{item.addtime}}</p >-->
    <!--                        <p class="news_content">{{item.title}}</p >-->
    <!--                        <p class="news_more">详细内容...</p>-->
    <!--                        <div class="line_under"></div>-->
    <!--                    </div>-->
    <!--                </router-link>-->
    <!--            </div>-->
    <!--        </yd-tab-panel>-->
    <!--        <yd-tab-panel v-if="news_classify.length" :label="news_classify[0].title">-->
    <!--            <div class="selected_cars" v-for="(item, index) in newsArr" :key="index">-->
    <!--                <router-link :to="{path:'/Details',query:{id:newsArr[index].news_id}}">-->
    <!--                    <img :src="item.picname" alt=""  class="news_img"/>-->
    <!--                    <div class="text">-->
    <!--                        <p class="time">{{item.addtime}}</p >-->
    <!--                        <p class="news_content">{{item.title}}</p >-->
    <!--                        <p class="news_more">详细内容...</p>-->
    <!--                        <div class="line_under"></div>-->
    <!--                    </div>-->
    <!--                </router-link>-->
    <!--            </div>-->
    <!--        </yd-tab-panel>-->
    <!--      </yd-tab>-->
    <!--      选项卡结束-->
    <div class="news_list">
      
      <!--        <Aqt-Refresh class="pull">-->
      <div class="new_title">
        <div class="line line1"></div>
        <p class="title title_size1">阿启泰最新动态</p>
        <p class="title title_size2">在这里，您可以找到阿启泰团队最新新闻和项目开发更新。按新闻类别进行查询。</p>
      </div>
      <div class="selected_cars" v-for="(item, index) in newsArr" :key="index">
        <router-link :to="{path:'/Details',query:{id:item.id}}">
          <img :src="item.img" alt="" class="news_img"/>
          <div class="text">
            <p class="time">{{ item.addtime }}</p>
            <p class="news_content">{{ item.title }}</p>
            <p class="news_more">详细内容...</p>
            <div class="line_under"></div>
          </div>
        </router-link>
      </div>
      <Page :total="total" v-if="total>5" class="pages" @on-change="handleChange()"></Page>
    </div>
  
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  
  data() {
    return {
      newsArr: [],
      aqtArr: [],
      otherArr: [],
      //数据总条数
      total: 1,
      //下一页页数
      last_page: 1,
      //每页的数据个数
      per_page: 1,
      //当前页数
      current_page: 1,
      //上一页页数
      prev_page: 1,
      //跳转后页码的新数据
      pageList: []
    }
  },
  methods: {
    //初始化数据
    change(event) {
      const that = this
      that.newsArr = []
      that.screening(1)
      
    },
    //第一页的数据
    screening(pages = 1) {
      const that = this
      // http://admin.aqitai.com/Home/Index/NewsList?page='
      axios.get('http://oaapi.aqitai.com/api/v1/News/pcindex?page=' + pages).then(val => {
        /*console.log(val)
         that.total = Number(val.data.page.total);
         that.per_page = Number(val.data.page.per_page);
         that.last_page = Math.ceil(that.total/that.per_page);
         that.current_page = Number(val.data.page.current_page);
         console.log(val.data.page)
         for(var i=0;i<val.data.data.length;i++){
         that.newsArr.push(val.data.data[i]);
         };*/
        console.log(val)
        that.total = Number(val.data.data.total)
        that.per_page = Number(val.data.data.per_page)
        that.last_page = Math.ceil(that.total / that.per_page)
        that.current_page = Number(val.data.data.current_page)
        this.newsArr = val.data.data.data
      }).catch(err => {
      
      })
    },
    //点击分页触发跳转页面
    handleChange(current_page) {
      const that = this
      that.current_page = ++that.current_page
      if (that.prev_page > 1) {
        that.prev_page = --that.current_page
      }
      if (that.last_page < that.current_page) {
        this.screening(that.prev_page)
      } else if (that.last_page >= that.current_page) {
        this.screening(that.current_page)
      }
      that.newsArr = this.newsArr.slice((current_page - 1) * 9, current_page * 9)
    },
    
  },
  mounted() {
    const that = this
    that.change()
  }
  
}
</script>

<style scoped lang="less">
#aqt_content {
  height: 100%;
  padding-top: 70px;
  
  .news_list {
    width: 70%;
    height: auto;
    margin: 0px auto;
    margin-bottom: 2%;
  
    .new_title {
      margin-bottom: 8%;
      padding-top: 6%;
      
      .line {
        margin: 0 auto;
        width: 10%;
        height: 1px;
        text-align: center;
        margin-bottom: 7%;
      }
      
      .line1 {
        background-color: #F5A623;
      }
      
      .title {
        margin-left: 1%;
        margin-right: 1%;
        text-align: center;
        letter-spacing: 1px;
      }
      
      .title_size1 {
        font-size: 18px;
        color: #F4FAFF;
      }
      
      .title_size2 {
        font-size: 14px;
        color: #D3DFFF;
        line-height: 20px;
        margin-top: 3%;
      }
    }
    
    height: 100%;
    
    .selected_cars {
      width: 100%;
      height: 150px;
      margin-top: 2%;
      
      a {
        height: 100%;
        display: flex;
        flex-direction: row;
        
        .news_img {
          width: 25%;
          margin-left: 3%;
          margin-right: 3%;
        }
        
        .text {
          .time {
            font-size: 14px;
            color: #0070D2;
            margin-bottom: 10px;
          }
          
          .news_more {
            font-size: 012px;
            color: #D3DFFF;
            margin-top: 20px;
          }
          
          .line_under {
            width: 59px;
            height: 1px;
            background-color: #D3DFFF;
          }
          
          .news_content {
            font-size: 14px;
            line-height: 20px;
            color: #D3DFFF;
            letter-spacing: 0.5px;
            
          }
        }
      }
    }
    
    .pages {
     /* margin-left: 60%;
      margin-top: 5%;
      margin-bottom: 5%;*/
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
  }
  
  
}

</style>
